import clsx from "clsx";
import React, { ButtonHTMLAttributes } from "react";

import s from "./RowSelectionControl.less";

export type RowSelectionControlProps = {
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>["onClick"];
  onChange?: () => void;
};

export const RowSelectionControl = ({
  checked,
  disabled,
  className,
  onClick,
  onChange,
}: RowSelectionControlProps) => (
  <button
    type="button"
    className={clsx(
      s.rowSelection,
      checked && s.rowSelectionChecked,
      className,
    )}
    aria-pressed={Boolean(checked)}
    disabled={disabled}
    onClick={(event) => {
      onClick?.(event);
      onChange?.();
    }}
  >
    {checked && (
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden>
        <path
          d="M1.5 5.2L3.9 7.5L8.5 2.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </button>
);
